import servers from "./servers";

export default {
  [servers.user]: "https://testuser-api.jilingshu.com.cn",
  [servers.exam]: "https://testexam-center-service.jilingshu.com.cn",
  [servers.device]: "https://testapi.jilingshu.com.cn",
  [servers.authorization]: "https://testapi.jilingshu.com.cn",
};
